import Link from 'next/link'

import { NavItem } from '@/components/layout/nav-item'
import { cn } from '@/lib/utils/utils'
import { getLocalizedUri, I18nValue, LangCode, useI18nValue } from '../i18n/lang-context'
import { SubMenu } from '../jbda/sub-menu'
import { Button } from '../ui/button'

export function Nav({ navItems = [], className = '', langCode }: { navItems?: NavItem[], className?: string, langCode: LangCode }) {

  const i18nValue = useI18nValue()

  const getTitle = (title: string | I18nValue) => !title || typeof title === 'string' ? title : i18nValue(title, langCode)

  return (
    <nav className={cn('flex h-full items-center gap-0 xl:gap-4', className)}>
      {navItems?.map((item, index) => item.href && (
        <Link key={`_${index}`}
              href={getLocalizedUri(item.href, langCode)}
              onClick={() => {if(item.scrollBefore) window.scrollTo(0, 0)}}
              className='flex items-center'>
          <Button variant='link' className={cn('text-[14px] font-medium text-foreground opacity-75')}>
            {getTitle(item.title)}
          </Button>
        </Link>
      ) || item.onClick && (
        <Button key={`__${index}`} variant={'link'}
                className={cn('text-[14px] font-medium text-foreground opacity-75')}
                onClick={item.onClick()}>
          {getTitle(item.title)}
        </Button>
      ) || item.subs && item.subs.length > 0 && (
        <SubMenu title={getTitle(item.title)} navItems={item.subs} key={`___${index}`} langCode={langCode} />
      ))}
    </nav>
  )
}
